<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择物料"
      width="900px"
      top="8vh"
  >
    <view-table
        ref="tableSelect"
        :filter="filter"
        :sel-reset="true"
        :columns="columns"
        module="basic"
        url="sapProductionOrderDetails"
        @select="selectHandle"
        @reset="resetHandle"
    >
      <template slot="otherBtn">
        <el-button type="primary" @click="selectRows">添加</el-button>
      </template>
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="工单号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </view-table>
  </el-dialog>
</template>

<script>
  import ViewTable from "@/components/ViewTable";

  export default {
    name: "MaterialSelectByFilter",
    components: {ViewTable},
    data() {
      return {
        dialogVisible: false,
        filter: {
          billNo: "",
          queryType: "",
        },
        columns: [
          {
            title: "物料编号",
            key: "materialCode",
            width: 160,
          },
          {
            title: "物料名称",
            key: "materialDescription",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
          },
        ],
      };
    },
    methods: {
      open(row) {
        console.log(row);
        if (row.relBillNo) {
          this.filter.billNo = row.relBillNo;
          console.log(this.filter.billNo);
        }
        if (row.queryType) {
          this.filter.queryType = row.queryType;
        }
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },
      selectHandle(selection) {
        this.selection = selection;
      },
      // selectMaterial(row) {
      //   this.dialogVisible = false;
      //   this.$emit("select", row);
      // },
      selectRows() {
        this.dialogVisible = false;
        this.$emit("select", this.selection);
      },

      // 重置特殊处理
      resetHandle() {
        this.filter.billNo = "";
        this.filter.queryType = "";
        this.$refs.tableSelect.loadData();
      },
    },
  };
</script>
